import { publishReplay, refCount } from "rxjs/operators";
import type { Observable } from "rxjs";
import { ReplaySubject } from "rxjs";
import type { ITokenHolderService } from "./ITokenHolderService";

import type { IToken } from "../../../Models";

import "angular-jwt";
import "angular-local-storage";

const tokenName = "token";

export class TokenHolderService implements ITokenHolderService {
    public static $inject = ["$q", "$timeout", "$window", "$document", "localStorageService"];

    private readonly tokenSubject: ReplaySubject<IToken>;

    private readonly tokenSubscription: Observable<IToken>;

    constructor(
        private readonly $q: ng.IQService,
        private readonly $timeout: ng.ITimeoutService,
        private readonly $window: ng.IWindowService,
        private readonly $document: ng.IDocumentService,
        private readonly localStorageService: angular.local.storage.ILocalStorageService,
    ) {
        this.tokenSubject = new ReplaySubject(1);
        this.tokenSubject.next(this.getToken());

        this.tokenSubscription = this.tokenSubject.pipe(publishReplay(1), refCount());

        if ($window.addEventListener) {
            $window.addEventListener("storage", (event) => {
                if (!event.key) {
                    return;
                }

                const storageKeyPrefix = "ir.";
                const prefixLength: number = storageKeyPrefix.length;

                if (storageKeyPrefix === event.key.slice(0, prefixLength)) {
                    const key: string = event.key.slice(prefixLength);
                    if (key === tokenName) {
                        if (event.newValue) {
                            this.tokenSubject.next(JSON.parse(event.newValue) as IToken);
                        } else {
                            this.tokenSubject.next(null);
                        }
                    }
                }
            });
        }
    }

    public tokenObservable(): Observable<IToken> {
        return this.tokenSubscription;
    }

    public getToken(): IToken {
        return this.localStorageService.get(tokenName) as IToken;
    }

    public setToken(token: IToken): void {
        if (token && token.accessToken) {
            this.localStorageService.set(tokenName, {
                accessToken: token.accessToken,
                refreshToken: token.refreshToken,
            });
            this.tokenSubject.next(token);
        } else {
            this.tokenSubject.next(null);
        }
    }

    public deleteToken(): void {
        if (this.localStorageService.get(tokenName)) {
            this.localStorageService.remove(tokenName);
            this.tokenSubject.next(null);
        }
    }
}
